import axios from 'axios';
import intl from 'react-intl-universal';
import { store } from 'Store/index';
import { convertUTCToLocale, getFileSize } from 'Utils/utils';
import { PRIVATE_DRIVE_API } from './private_drive.api.constant';
import { baseUrlApis } from '../index';
import { URL_PLATFORM } from '../constants';
import { HttpRequest } from '../request.utils'

export default class PrivateDriveApi extends HttpRequest {
  constructor() {
    super();
    this.CancelToken = axios.CancelToken;
    this.downloadFileRequest = false;
    this.uploadFileRequest = false;
    this.privateDriveAxios = null;
    this.cancelDownloadFileFn = null;
    this.cancelUploadFileFn = null;

    this.init();
  }
  async init() {
    let result = '';

    try {
      result = await baseUrlApis.getBaseUrlBy(URL_PLATFORM);
    } catch (error) {
      console.error('getBaseUrl failed');
    }

    this.privateDriveAxios = axios.create({
      baseURL: `${result}/platform`,
    });
    let requestCfg = {
      success: (config) => {
        store.privateDriveStore.numberOfAjaxCAllPendingIncrease();

        return config;
      },
      error: (error) => {
        store.privateDriveStore.numberOfAjaxCAllPendingDecrease();

        Promise.reject(error);
      }
    };


    let responseCfg = {
      success: (response) => {
        store.privateDriveStore.numberOfAjaxCAllPendingDecrease();

        if (response.data instanceof Blob) {
          if (response.data.type === 'application/json') {
            let invalidPublicKey = intl.formatMessage({ id: 'InvalidPublicKey' });

            store.appStore.setGlobalMessage({ type: 'error', content: invalidPublicKey });

            setTimeout(() => {
              signOut();
            }, 1500);

            return Promise.reject(response);
          } else {
            return response.data;
          }
        } else {
          let { ret } = response.data;

          if (ret === 0) {
            return response.data;
          } else {
            let errorMsg;
            let noShowMsg = false;

            if (ret === 10004) {
              let unKnownUserNameOrPassword = intl.formatMessage({ id: 'UnKnownUserNameOrPassword' });

              errorMsg = unKnownUserNameOrPassword;
            } else if (ret === 300032) {
              let invalidPublicKey = intl.formatMessage({ id: 'InvalidPublicKey' });

              errorMsg = invalidPublicKey;

              setTimeout(() => {
                signOut();
              }, 1500);
            } else if (ret === 10001) {
              noShowMsg = true;
            } else if (ret === 110010) {
              let docExist = intl.formatMessage({ id: 'DocExist' });

              errorMsg = docExist;
            } else {
              let unKnownError = intl.formatMessage({ id: 'UnKnownError' });

              errorMsg = unKnownError;
            }

            !noShowMsg && store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });

            return Promise.reject(response);
          }
        }

        function signOut() {
          const { selectedStorage } = store.privateDriveStore;

          store.privateDriveStore.setAuthenticationParams({ RSAPublicKey: '', username: '', password: '' });
          store.privateDriveStore.setIsSignIn({ storage: JSON.parse(JSON.stringify(selectedStorage)), isSignIn: false });
          store.privateDriveStore.cleanFolderPath();
          store.privateDriveStore.setFilesData({ storage: selectedStorage, data: [] });
          store.privateDriveStore.setSelectedStorage({});
          store.privateDriveStore.setShowSignInPanel(true);
        }
      },
      error: (error) => {
        store.privateDriveStore.numberOfAjaxCAllPendingDecrease();

        return Promise.reject(error);
      },
    }
    super.initialize(this.privateDriveAxios, () => {
      this.interceptorsProxyFn(requestCfg, responseCfg);
    });
  }
  getAuthentication() {
    const { apiAuthenticationParams, selectedStorage } = store.privateDriveStore;
    let rsaPublicKey = '';
    let username = '';
    let password = '';
    let result;

    if (selectedStorage.type === 3) {
      result = '';
    } else {
      apiAuthenticationParams.forEach((item) => {
        let { storage, username: usernameForCurrentStorage, password: passwordForCurrentStorage, RSAPublicKey } = item;

        if (
          storage.alias === selectedStorage.alias &&
          storage.bucket === selectedStorage.bucket &&
          storage.endpoint === selectedStorage.endpoint &&
          storage.type === selectedStorage.type
        ) {
          rsaPublicKey = RSAPublicKey;
          username = usernameForCurrentStorage;
          password = passwordForCurrentStorage;
        }
      });

      let pk = `-----BEGIN PUBLIC KEY-----${rsaPublicKey}-----END PUBLIC KEY-----`;

      return import('jsrsasign')
      .then(module=>{

        let pub = module.KEYUTIL.getKey(pk);
        let enc = module.KJUR.crypto.Cipher.encrypt(`${username};${password}`, pub);
  
        enc = module.hextob64(enc);
  
        result = `S8-API ${rsaPublicKey},${enc}`;
        return result;
      })
    }

    return Promise.resolve(result);
  }
  getConfig(success, fail) {
    this.get({
      url: PRIVATE_DRIVE_API.STORAGE_CONFIG,
      config: {
        params: {
          access_token: store.userStore.token,
        },
      },
    })
      .then((res) => {
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  getRSAPublicKey(success, fail) {
    this.get({
      url: PRIVATE_DRIVE_API.RSA_PUBLIC_KEY,
      config: {
        params: {
          expired: 30,
        },
      },
    })
      .then((res) => {
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  getItems(path, success, fail) {
    const { selectedStorage } = store.privateDriveStore;

    this.getAuthentication()
    .then(token=>{
      this.get({
        url: PRIVATE_DRIVE_API.GET_FILES,
        config: {
          headers: {
            Authentication: token,
          },
          params: {
            access_token: store.userStore.token,
            alias: selectedStorage.alias,
            path,
          },
        }
      })
        .then((res) => {
          let folders = [];
          let files = [];
  
          res.data &&
            res.data.files &&
            res.data.files.forEach((item) => {
              item.modifiedTime = item.date !== 0 ? convertUTCToLocale(new Date(item.date)) : ' ';
              item.isFolder = item.dir;
  
              if (item.isFolder) {
                item.text = item.name.slice(0, -1);
                item.size = null;
                folders.push(item)
              } else if (/(\.pdf)$/.test(item.name)) {
                item.text = item.name;
                item.size = item.size !== 0 ? getFileSize(item.size) : ' ';
                files.push(item)
              }
            });
          folders.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
  
            return 0;
          });
          files.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
  
            return 0;
          });
  
          success && success([...folders, ...files]);
        })
    })
    
      .catch((error) => {
        fail && fail(error);
      });
  }
  downloadFile(path, item, success, fail) {
    this.downloadFileRequest = true;
    this.getAuthentication()
    .then(token=>
      this.get({
      url: PRIVATE_DRIVE_API.DOWNLOAD_FILE,
      config: {
        headers: {
          Authentication: token,
        },
        params: {
          access_token: store.userStore.token,
          alias: store.privateDriveStore.selectedStorage.alias,
          path: `${path}${item.name}`,
        },
        responseType: 'blob',
        cancelToken: new this.CancelToken((c) => {
          // An executor function receives a cancel function as a parameter
          this.cancelDownloadFileFn = c;
        }),

      }
    }))
      .then((blob) => {
        this.downloadFileRequest = false;
        success && success(blob);
      })
      .catch((error) => {
        this.downloadFileRequest = false;
        fail && fail(error);
      });
  }
  cancelDownloadFile() {
    this.cancelDownloadFileFn && this.cancelDownloadFileFn();
  }
  updateFile(path, file, success, fail) {
    const { selectedStorage } = store.privateDriveStore;
    let fd = new FormData();

    fd.append('file', file);
    this.getAuthentication()
    .then(token=>this.post({
      url: PRIVATE_DRIVE_API.UPLOAD_FILE,
      config: {
        headers: {
          Authentication: token,
        },
        params: {
          access_token: store.userStore.token,
          alias: selectedStorage.alias,
          path,
          override: 1,
          filename: file.name,
        },
      },
      data: fd,
    }))
      .then((res) => {
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  uploadFile(path, file, success, fail) {
    const { selectedStorage } = store.privateDriveStore;
    let fd = new FormData();

    fd.append('file', file);

    this.uploadFileRequest = true;
    this.getAuthentication()
    .then(token=>
    this.post({
      url: PRIVATE_DRIVE_API.UPLOAD_FILE,
      config: {
        headers: {
          Authentication: token,
        },
        params: {
          access_token: store.userStore.token,
          alias: selectedStorage.alias,
          path,
          override: 1,
          filename: file.name,
        },
        cancelToken: new this.CancelToken((c) => {
          // An executor function receives a cancel function as a parameter
          this.cancelUploadFileFn = c;
        }),
      },
      data: fd,
    }))
      .then((res) => {
        this.uploadFileRequest = false;
        success && success(res);
      })
      .catch((error) => {
        this.uploadFileRequest = false;
        fail && fail(error);
      });
  }
  cancelUploadFile() {
    this.cancelUploadFileFn && this.cancelUploadFileFn();
  }
}
